const timestampToHuman = (utcTimestamp) => {
  return new Date(utcTimestamp * 1000).toLocaleString("en-US");
};

export default timestampToHuman;
